import styled, {css} from 'styled-components';

import {colors, transition} from '@app/styles/theme';

import {ReactComponent as ArrowIcon} from '@pages/Relations/assets/arrow.svg';
import {Button} from '@shared/ui/Button';

const cardStyles = css`
    background: ${colors.white};
    border: 1px solid ${colors.border};
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(17, 17, 17, 0.04);
`;

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: calc(100vh - 86px);
`;

export const Card = styled.div`
    ${cardStyles};
    padding: 16px;
`;

export const ChartCard = styled.div`
    ${cardStyles};
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const ControlsRow = styled.div`
    display: flex;
    gap: 16px;
    align-items: flex-start;
    flex-wrap: wrap;
`;

export const FiltersRow = styled.div`
    display: flex;
    gap: 16px;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
`;

export const ActionGroup = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
`;

export const ExportButton = styled(Button)`
    &:disabled {
        color: ${colors.textSecondary};
    }
`;

const buttonBase = css<{isActive?: boolean}>`
    border: 1px solid ${({isActive}) => (isActive ? colors.brandPrimary : colors.border)};
    background: ${({isActive}) => (isActive ? colors.brandPrimary : colors.white)};
    color: ${({isActive}) => (isActive ? colors.white : colors.textPrimary)};
    border-radius: 999px;
    padding: 10px 16px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all ${transition.duration};

    &:hover {
        border-color: ${colors.brandDark};
        color: ${({isActive}) => (isActive ? colors.white : colors.brandDark)};
    }
`;

export const OptionButton = styled.button<{isActive?: boolean}>`
    ${buttonBase};
    min-width: 140px;
    border-radius: 8px;
`;

export const FilterButton = styled.button<{isActive?: boolean}>`
    ${buttonBase};
`;

export const InputBlock = styled.div`
    position: relative;
`;

export const InputRow = styled.div`
    display: grid;
    grid-template-columns: minmax(280px, 1fr) 140px;
    gap: 12px;
    max-width: 300px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const Helper = styled.div`
    position: absolute;
    top: calc(100%);
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 250px;
    color: ${colors.textSecondary};

    & > span {
        position: relative;
        left: 65px;
        top: 5px;
    }
`;

export const HelperArrow = styled(ArrowIcon)`
    width: 137px;
    height: 291px;
    color: ${colors.brandPrimary};
`;

export const ChartContainer = styled.div`
    position: relative;
    flex: 1 1 auto;
    overflow: hidden;
    border-top: 1px solid ${colors.border};
    min-height: 460px;
`;
